import { types } from "mobx-state-tree"

const LoginUIStore = types.model({
    username: types.string,
    password: types.string
})
.actions(self=>({
    setUsername: (value)=>{
        self.username = value;
    },
    setPassword: (value)=>{
        self.password = value;
    },
    reset:()=>{
        self.username = '';
        self.password = '';
    }
}))

export default LoginUIStore.create({
    username: '',
    password: ''
})


// WEBPACK FOOTER //
// ./src/stores/LoginUIStore.js